module.exports = __webpack_public_path__ + "img/penjaminan_aman.2485d3f8.png";